import React from "react";
import moment from "moment";
import { Typography, Collapse, Tag } from "antd";
import Actions from "./Actions";
import FeedItemContent from "./FeedItemContent";
import useFeedItem from "../../hooks/useFeedItem";
import { useIntl } from "react-intl";

const { Text, Link } = Typography;
const { Panel } = Collapse;

const FeedItem = ({
  record,
  entity,
  entityId,
  branchId,
  reload,
  onEditActivity,
}) => {
  const {
    contextHolder,
    show_complete_button,
    show_cancel_button,
    show_delete_button,
    onCompleteTask,
    onCancelActivity,
    onDeleteActivity,
    actionText,
  } = useFeedItem(record, entity, entityId, branchId, reload);
  const { task, event, id } = record;
  const intl = useIntl();
  const subject = task ? task.subject : event.subject;
  const due_date = task ? task.due_date : null;
  const start_time = event ? event.start_time : null;

  return (
    <div>
      {contextHolder}
      <Collapse ghost className="custom-collapse" collapsible="icon">
        <Panel
          header={
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <Link target="_blank">{subject}</Link>
                  {!show_cancel_button && task && task.type === "task" && (
                    <Tag color="error">
                      {intl.formatMessage({
                        id: "app.dataSelect.taskType.cancelled",
                      })}
                    </Tag>
                  )}
                </div>
                <Text type="secondary">{actionText()}</Text>
              </div>
              <div
                style={{
                  width: "fit-content",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "end",
                }}
              >
                <Actions
                  record={record}
                  show_complete_button={show_complete_button}
                  show_cancel_button={show_cancel_button}
                  show_delete_button={show_delete_button}
                  onCompleteTask={onCompleteTask}
                  onCancelActivity={onCancelActivity}
                  onEditActivity={onEditActivity}
                  onDeleteActivity={onDeleteActivity}
                />
                <Text type="secondary">
                  {moment(due_date || start_time)
                    .startOf("minute")
                    .fromNow()}
                </Text>
              </div>
            </div>
          }
          key={id}
        >
          <FeedItemContent record={record} />
        </Panel>
      </Collapse>
    </div>
  );
};
export default FeedItem;
